import React, { Component } from 'react';
import QrReader from 'react-qr-reader'
import request from './request';
import imgScanner from './assets/QR-Scanner-FA.png'

class App extends Component {
  state = {
    result: null,
    showScanner: false,
  }
  
  render() {
    const {
      result,
      showScanner,
    } = this.state;
    let divResult = null;

    if (result) {
      try {
        // if result is valid
        if (result.name && result.amount && result.nricLastDigits) {
        const name = result.name;
        const amount = result.amount;
        const nricLastDigits = result.nricLastDigits;
        divResult = <div style={{ width: '300px', 'font-family': 'Roboto, sans-serif', 'font-size': '12px', }}>
            <div><b>အမည် - </b> {name}</div>
            <div><b>ဝယ်ယူထားသည့် ငွေတိုက်စာချုပ်တန်ဖိုး - </b> {amount} USD</div>
            <div><b>မှတ်ပုံတင်အမှတ် (နောက်ဆုံး ၄လုံး) - </b> {nricLastDigits}</div>
          </div>;
        } else {
          // if result is not valid
          divResult = <div>
            <div>Invalid QR code</div>
          </div>;
        }
      } catch (error) {
        console.log(error);
        if (result._response.status !== 200) {
          // if result bad request
          divResult = <div>
            <div>Invalid QR code</div>
          </div>;
        }
      }
    } else {
      if (showScanner) {
        divResult = <div style={{ width: '310px', height: '310px', cursor: 'pointer' }}><QrReader
          delay={100}
          onError={err => {
            console.error(err)
          }}
          onScan={data => {
            this.scanData(data)
          }}
          
          style={{ width: '300px' }}
        /></div>
      } else {
        divResult = <div style={{ width: '300px', height: '300px', cursor: 'pointer', 'background-image': 'radial-gradient(#e3e3e3 5%, #e3e3e3 25%, #f0f0f0 35%)',  'border-radius': '25px' }}><img src={imgScanner} alt="Logo" style={{ width: '150px', cursor: 'pointer', padding: '75px' }} onClick={() => this.displayScanner()} /></div>;
      }
    }
    
    return (
      <div className="App-container">
        {divResult}
      </div>
    )
  };

  async scanData(data) {
    if (data) {
      const options = {}
      options.headers = {
        'x-functions-key': 'xIj48pRwm7eTGEHlw2aKYWTrjh56dsH8faRT1Q4ePKoFlUo7azpbLw==',
      };

      const result = await request.post('https://faunitedbonds.azurewebsites.net/api/VerifyQRCode', data, options);
      this.setState({
        result,
      });
      return result;
    }
  }

  displayScanner() {
    this.setState({
      showScanner: true,
    });
  }
}

export default App;